import AppConstants from '../config/app.constants';

let RegionRoutingService = function ($http, $q) {

    let getLocations = (title, latDetails, longDetails, branch, searchText, limit, offset, zonePolygon) => {
        return $http
            .get(AppConstants.api + `/region-routing/get-locations/`, {
                params: {
                    title,
                    latDetails,
                    longDetails,
                    branch,
                    searchText,
                    limit,
                    offset,
                    zonePolygon: zonePolygon ? JSON.stringify(zonePolygon) : null
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let getAllLocations = (limit, offset) => {
        return $http
            .get(AppConstants.api + `/region-routing/get-all-locations/`, {
                params: {
                    limit,
                    offset
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let createLocationZone = (loggedInUser, branch, title, /* type, */ latDetails, longDetails, dayOfWeek, shape, locationData, limit, offset) => {
        return $http
            .post(AppConstants.api + `/region-routing/create-location-zone/`, {
                loggedInUser,
                branch,
                title,
                // type,
                latDetails,
                longDetails,
                dayOfWeek,
                shape,
                locationData,
                limit,
                offset
            })
            .then((res) => {
                return res.data
            })
    };

    let updateLocationZone = (loggedInUser, branch, title, id, /* type, */ latDetails, longDetails, dayOfWeek, shape, locationData, limit, offset) => {
        return $http
            .post(AppConstants.api + `/region-routing/update-location-zone/`, {
                loggedInUser,
                branch,
                title,
                id,
                // type,
                latDetails,
                longDetails,
                dayOfWeek,
                shape,
                locationData,
                limit,
                offset
            })
            .then((res) => {
                return res.data
            })
    };

    let getDayWiseLocationZone = (branch, day) => {
        return $http
            .get(AppConstants.api + `/region-routing/get-day-wise-location-zone/`, {
                params: { branch, day }
            })
            .then((res) => {
                return res.data
            })
    };

    let deleteLocationZone = (id, name, branchId) => {
        return $http
            .delete(AppConstants.api + `/region-routing/${id}`, {
                params: {
                    id, name, branchId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getLocationZoneCount = (branch) => {
        return $http
            .get(AppConstants.api + `/region-routing/get-location-zone-count/`, {
                params: { branch }
            })
            .then((res) => {
                return res.data
            })
    }

    let syncZoneLocations = (locationZoneId) => {
        return $http
            .post(AppConstants.api + `/region-routing/${locationZoneId}/sync-zone-locations`)
            .then((res) => {
                return res.data
            })
    };

    let getLocationZoneRules = (locationZoneId, limit, offset) => {
        return $http
            .get(AppConstants.api + `/region-routing/location-zone-rules/${locationZoneId}`, {
                params: { limit, offset }
            })
            .then((res) => {
                return res.data
            })
    };

    let getAssignableUsersForZone = (locationZoneId, search, limit, offset) => {
        return $http
            .get(AppConstants.api + `/region-routing/location-zone-rules/${locationZoneId}/assignable-users`, {
                params: { search, limit, offset }
            })
            .then((res) => {
                return res.data
            })
    };

    let getAssignableCustomersForZone = (locationZoneId, search, limit, offset) => {
        return $http
            .get(AppConstants.api + `/region-routing/location-zone-rules/${locationZoneId}/assignable-customers`, {
                params: { search, limit, offset }
            })
            .then((res) => {
                return res.data
            })
    };

    let createLocationZoneRule = (locationZoneId, payload) => {
        return $http
            .post(AppConstants.api + `/region-routing/location-zone-rules/${locationZoneId}`, payload)
            .then((res) => {
                return res.data
            })
    };

    let updateLocationZoneRule = (locationZoneId, ruleId, payload) => {
        return $http
            .post(AppConstants.api + `/region-routing/location-zone-rules/${locationZoneId}/${ruleId}/update`, payload)
            .then((res) => {
                return res.data
            })
    };


    let deleteLocationZoneRule = (locationZoneId, ruleId) => {
        return $http
            .delete(AppConstants.api + `/region-routing/location-zone-rules/${locationZoneId}/${ruleId}`)
            .then((res) => {
                return res.data
            })
    };

    let reorderLocationZoneRules = (locationZoneId, rules) => {
        return $http
            .post(AppConstants.api + `/region-routing/location-zone-rules/${locationZoneId}/reorder`, { rules })
            .then((res) => {
                return res.data
            })
    };

    let bulkAllDaySaveLocationZones = (payload) => {
        return $http
            .post(AppConstants.api + `/region-routing/bulk-all-days-save-location-zones/`, {
                ...payload
            })
            .then((res) => {
                return res.data
            })
    };
    return {
        getAllLocations,
        getLocations,
        createLocationZone,
        updateLocationZone,
        getDayWiseLocationZone,
        deleteLocationZone,
        getLocationZoneCount,
        syncZoneLocations,
        getLocationZoneRules,
        getAssignableUsersForZone,
        getAssignableCustomersForZone,
        createLocationZoneRule,
        updateLocationZoneRule,
        deleteLocationZoneRule,
        reorderLocationZoneRules,
        bulkAllDaySaveLocationZones
    };
};

RegionRoutingService.$inject = ['$http', '$q']

export default RegionRoutingService;



// WEBPACK FOOTER //
// ./client/app/services/region-routing.service.js